import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		const queryStr =
			objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				endDt: searchParams.endDt.replaceAll('-', ''),
				partNo: searchParams.partNo,
				rgnId: searchParams.rgnId,
				powCd: searchParams.powCd,
				badClCd: searchParams.badClCd,
				badScnCd: searchParams.badScnCd,
				serialNo: searchParams.serialNo,
				currentPage,
				pageUnit
			}) || '';
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/overSrgAltr/v1/overSrgAltrs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deleteOverSrgAltrList(delRows) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/overSrgAltr/v1/status/2/updateDelYn`, delRows);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateUnit(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/overSrgAltr/v1/status/2/overSrgNo/${param.overSrgNo}`, param);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updatePartNo(param) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/overSrgAltr/v1/status/2/overSrgNo/${param.overSrgNo}/partNo/${param.partNo}`,
				param
			);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
